import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'boxicons'
import { store } from './store/store'

// Install BootstrapVue
Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  store: store,
  render: h => h(App)
}).$mount('#app')
